export const STT_SERVICES = [
    { value: 'deepgram', text: 'Deepgram' },
    { value: 'google',   text: 'Google'   },
    { value: 'uhlive',   text: 'UHLive'   },
    { value: 'gladia',   text: 'Gladia'   },
    { value: 'gradium',  text: 'Gradium'  },
]

export const STT_PARAMS = {
    deepgram: [
        { key: 'language', label: 'Language', type: 'text', default: 'fr' },
        {
            key: 'model', label: 'Model', type: 'dropdown',
            options: ['nova-2', 'nova-2-general', 'nova-2-phonecall', 'nova-2-finance', 'nova-2-medical', 'nova-2-meeting'],
            default: 'nova-2'
        },
    ],
    google: [
        { key: 'language', label: 'Language', type: 'text', default: 'fr-FR' },
        {
            key: 'model', label: 'Model', type: 'dropdown',
            options: ['latest_long', 'latest_short', 'phone_call', 'telephony', 'telephony_short', 'medical_dictation', 'medical_conversation'],
            default: 'latest_short'
        },
    ],
    uhlive: [
        { key: 'language', label: 'Language', type: 'text', default: 'fr-FR' },
        { key: 'builtin', label: 'Builtin', type: 'text', default: 'speech/transcribe' },
        { key: 'speech_complete_timeout', label: 'Speech Complete Timeout (ms)', type: 'number', default: 1000 },
        { key: 'no_input_timeout', label: 'No Input Timeout (ms)', type: 'number', default: 5300 },
        { key: 'speech_incomplete_timeout', label: 'Speech Incomplete Timeout (ms)', type: 'number', default: 2000 },
        { key: 'recognition_timeout', label: 'Recognition Timeout (ms)', type: 'number', default: 30000 },
    ],
    gladia: [
        { key: 'language', label: 'Language', type: 'text', default: '' },
        {
            key: 'model', label: 'Model', type: 'dropdown',
            options: ['solaria-1'],
            default: 'solaria-1'
        },
        { key: 'endpointing', label: 'Endpointing (0-1)', type: 'number', default: '' },
        { key: 'maximum_duration_without_endpointing', label: 'Max Duration Without Endpointing (s)', type: 'number', default: '' },
        { key: 'speech_threshold', label: 'Speech Threshold (0-1)', type: 'number', default: '' },
        { key: 'api_key', label: 'API Key', type: 'text', default: '' },
    ],
    gradium: [
        {
            key: 'language', label: 'Language', type: 'dropdown',
            options: ['fr', 'en', 'de', 'es', 'pt'],
            default: 'fr'
        },
        {
            key: 'model', label: 'Model', type: 'dropdown',
            options: ['default'],
            default: 'default'
        },
        { key: 'temp', label: 'Temperature (0-1)', type: 'number', default: 0.0 },
        {
            key: 'delay_in_frames', label: 'Delay in Frames', type: 'dropdown',
            options: [7, 8, 10, 12, 14, 16, 20, 24, 32, 36, 48],
            default: 10
        },
        { key: 'padding_bonus', label: 'Padding Bonus (-4 to 4)', type: 'number', default: 0.0 },
        { key: 'api_key', label: 'API Key', type: 'text', default: '' },
    ],
}
